/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

// a counter that flips like an old-school clock.
//
// call `new FlipCounter(el, {params})`, where el is a required jQuery object
// and params (all optional) are:
// - direction {"up" or "down", optional} - which way the flip should go
// - number {int} - an initial value to throw in the dom
// - lowerBound {int} - when the counter is going down and gets below this, wrap
// - lowerWrap {int} - what to go to once you've passed the lowerBound
// - padZeroes {int} - how many total characters should be in the display
//
// after initializing, you may call increment(), decrement(), or flip(int),
// where int is the delta

let $ = jQuery;

window.FlipCounter = class FlipCounter {
	constructor(el, params) {
		if (params == null) {
			params = {};
		}
		if (el == null || !el.length) {
			return;
		}

		// set param defaults
		if (
			params.direction == null ||
			(params.direction != null &&
				(params.direction !== "up" || params.direction !== "down"))
		) {
			params.direction = "down";
		}

		if (!params.number) {
			params.number = 0;
		}

		if (!params.padZeroes) {
			params.padZeroes = 0;
		}

		// save settings on the FlipCounter object
		this.duration = 400; // this should be >= $duration in flip_counter.scss
		this.direction = params.direction;
		this.number = params.number;
		this.lowerWrap = params.lowerWrap;
		this.lowerBound = params.lowerBound;
		this.padZeroes = parseInt(params.padZeroes, 10);
		this.flipper = el;
		this.hasAnimation = Modernizr.cssanimations;

		// add the flipper html components to the wrapper
		this.addDomElements();

		// cache dom elements
		this.bgTop = this.flipper.find(".background_top");
		this.bgBottom = this.flipper.find(".background_bottom");
		this.front = this.flipper.find(".front");
		this.back = this.flipper.find(".back");

		// set the initial number and direction
		this.initializeDomElements();
	}

	increment() {
		return this.flip(1);
	}

	decrement() {
		return this.flip(-1);
	}

	flip(delta) {
		this.prepareTransition(delta);

		if (this.hasAnimation) {
			this.flipper.addClass("flip");

			return setTimeout(() => {
				this.number = this.nextNumber;
				return this.reset();
			}, this.duration);
		} else {
			this.number = this.nextNumber;
			return this.setNumber();
		}
	}

	// prepare the el for a flip by setting the current and next number
	prepareTransition(delta) {
		// get the next number
		if (delta == null) {
			delta = 1;
		}
		this.nextNumber = this.number + delta;

		if (delta < 0 && this.lowerWrap && this.nextNumber < this.lowerBound) {
			this.nextNumber = this.lowerWrap;
		}

		let num = this.padNumber(this.number);
		let nextNum = this.padNumber(this.nextNumber);

		if (this.hasAnimation) {
			if (this.direction === "up") {
				this.bgTop.text(num);
				this.bgBottom.text(nextNum);
				this.front.text(num);
				return this.back.text(nextNum);
			} else {
				this.bgTop.text(nextNum);
				this.bgBottom.text(num);
				this.front.text(num);
				return this.back.text(nextNum);
			}
		}
	}

	// set to the current number and remove the flip class without a transition
	reset() {
		this.setNumber();

		this.flipper.addClass("no_transition");
		this.flipper.removeClass("flip");
		this.flipper.css("width"); // trigger a redraw
		return this.flipper.removeClass("no_transition");
	}

	// instantly set all dom elements to the current number
	setNumber() {
		let num = this.padNumber(this.number);

		this.bgTop.text(num);
		this.bgBottom.text(num);
		this.front.text(num);
		return this.back.text(num);
	}

	// set the initial display number and add a direction class
	// (without a transition)
	initializeDomElements() {
		this.setNumber();

		this.flipper.addClass(`no_transition flip_${this.direction}`);
		this.flipper.css("width"); // trigger a redraw
		return this.flipper.removeClass("no_transition");
	}

	padNumber(num) {
		num = String(num);
		let numLength = num.length;
		let zeroesToAdd = this.padZeroes - numLength;

		if (zeroesToAdd > 0) {
			for (
				let i = 0, end = zeroesToAdd, asc = 0 <= end;
				asc ? i < end : i > end;
				asc ? i++ : i--
			) {
				num = `0${num}`;
			}
		}

		return num;
	}

	addDomElements() {
		return this.flipper.empty().append(`\
<div class="background_top"></div>
<div class="background_bottom"></div>
<div class="front"></div>
<div class="back"></div>\
`);
	}
};



// WEBPACK FOOTER //
// ./src/legacy/flip_counter.js